import type React from 'react';

import { PaymentMethodIcon, PaymentMethodList, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { StripeCreditCardLayout } from 'src/app/shared/components/payments';

import { ShareButton } from '../../../ShareButton';
import { NameInputWrapper } from '../NameInputWrapper';
import { SubmitButton } from '../SubmitButton';

import { useStripeCreditCard } from './useStripeCreditCard';

export const StripeCreditCard: React.FC = () => {
	const {
		data: { disabled, loading, ref, ...restData },
		actions,
	} = useStripeCreditCard();

	return (
		<div className="flex gap-3" data-testid="form-wrapper">
			<div className="rounded-large elevation-elevated w-full p-5" data-qa="credit-card-form">
				<div className="flex items-center justify-between pb-4">
					<Text fontWeight="bold" ref={ref} tabIndex={-1}>
						<Translate value="corgi.co.promote.payment_type_button.card" />
					</Text>
					<PaymentMethodList>
						<PaymentMethodIcon type="visa" variant="card" />
						<PaymentMethodIcon type="mastercard" variant="card" />
						<PaymentMethodIcon type="discover" variant="card" />
						<PaymentMethodIcon type="americanexpress" variant="card" />
					</PaymentMethodList>
				</div>
				<div className="flex flex-col gap-4">
					<StripeCreditCardLayout
						{...restData}
						{...actions}
						layout="single"
						submitButton={<SubmitButton disabled={disabled} loading={loading} />}
						displayErrorInAlert
						disabled={loading}
					>
						<NameInputWrapper disabled={loading} />
					</StripeCreditCardLayout>
					<ShareButton />
				</div>
			</div>
		</div>
	);
};
